import { FilterForm } from "@/types/filfer.type";
import axios from "axios";

export const SuiviDashboardService = {
  global: (filter: FilterForm) => {
    const queryParams = [];
    if (filter.year) queryParams.push(`year=${filter.year}`);
    if (filter.prov) queryParams.push(`prov=${filter.prov}`);
    if (filter.zs) queryParams.push(`zs=${filter.zs}`);
    if (filter.secteur) queryParams.push(`secteur=${filter.secteur}`);
    if (filter.partenaire) queryParams.push(`partenaire=${filter.partenaire}`);
    const queryString = queryParams.join("&");
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/serveillance/show-data?${queryString}`
    );
  },
  getPresentOrganisations: (filter: FilterForm) => {
    const queryParams = [];
    if (filter.year) queryParams.push(`year=${filter.year}`);
    if (filter.prov) queryParams.push(`prov=${filter.prov}`);
    if (filter.zs) queryParams.push(`zs=${filter.zs}`);
    if (filter.secteur) queryParams.push(`secteur=${filter.secteur}`);
    if (filter.partenaire) queryParams.push(`partenaire=${filter.partenaire}`);
    const queryString = queryParams.join("&");
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/serveillance/show-data/proportion?${queryString}`
    );
  },

  getGeography: (filter: FilterForm) => {
    const queryParams = [];
    if (filter.year) queryParams.push(`year=${filter.year}`);
    if (filter.prov) queryParams.push(`prov=${filter.prov}`);
    if (filter.zs) queryParams.push(`zs=${filter.zs}`);
    if (filter.partenaire) queryParams.push(`partenaire=${filter.partenaire}`);
    if (filter.secteur) queryParams.push(`secteur=${filter.secteur}`);
    const queryString = queryParams.join("&");
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/serveillance/show-data/geography?${queryString}`
    );
  },

  getActivities: (filter: FilterForm) => {
    const queryParams = [];
    if (filter.year) queryParams.push(`year=${filter.year}`);
    if (filter.prov) queryParams.push(`prov=${filter.prov}`);
    if (filter.zs) queryParams.push(`zs=${filter.zs}`);
    if (filter.partenaire) queryParams.push(`partenaire=${filter.partenaire}`);
    if (filter.secteur) queryParams.push(`secteur=${filter.secteur}`);
    const queryString = queryParams.join("&");
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/serveillance/show-data/activities?${queryString}`
    );
  },

  getOrganizations: async () => {
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/serveillance/organisations`
    );
  },

  getImpacts: async () => {
    return axios.get(
      `${process.env.NEXT_PUBLIC_API_URL}/serveillance/secteurs`
    );
  },
};
